"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var _b = _a.compData, tagName = _b.tagName, url = _b.url, initialAttributes = _b.initialAttributes, hostedInCorvid = _b.hostedInCorvid;
    return { tagName: tagName, url: url, initialAttributes: initialAttributes, hostedInCorvid: hostedInCorvid };
});
exports.css = withCompInfo_1.withCompInfo(['compLayout'], function (_a) {
    var _b = _a.compLayout, width = _b.width, height = _b.height;
    return ({
        width: 'auto',
        height: 'auto',
        '--customElementWidth': width + "px",
        '--customElementHeight': height + "px",
    });
});
//# sourceMappingURL=CustomElementComponent.js.map